import React from 'react';
import { useCustomers } from './CustomerContext';

export function withSelectedCustomer(Component) {
    return function WrappedComponent(props) {
        const { currentCustomer } = useCustomers();
        return <Component {...props} selectedCustomer={currentCustomer} />;
    }
}